import script from "./UpdaStore.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdaStore.vue?vue&type=script&setup=true&lang=js"

import "./UpdaStore.vue?vue&type=style&index=0&id=697f66b7&lang=css"

const __exports__ = script;

export default __exports__